import React from 'react';
export const Footer = () => {
  return <footer className="bg-[#0f1f10] text-white" data-id="element-275">
      <div className="container mx-auto px-4 md:px-8 py-6" data-id="element-276">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-3" data-id="element-277">
          <img src="https://cdn.magicpatterns.com/uploads/cGmqASMaWsiDkJPn4a1Kiz/logo_w_n_(1).svg" alt="Ikigai Real Estate" className="h-8 object-contain" data-id="element-278" />
          <p className="text-white/30 text-xs" data-id="element-279">
            © {new Date().getFullYear()} Ikigai Real Estate. All rights
            reserved.
          </p>
        </div>
      </div>
    </footer>;
};